/**
 * OCR 검수 모달로 바로 가는 주소 — `/ocr-hub/project/{프로젝트}?review={OCR 문제}`.
 *
 * 만드는 쪽은 문제 v2 상세 머리의 「OCR 등록」 배지(ProblemViewTab — 그냥 누르면 그 자리에 모달, ⌘·Ctrl 클릭이면
 * 이 주소를 새 탭으로), 읽는 쪽은 OCR 화면(pages/OcrHub →
 * useReviewDeepLink)이다. 매개변수 이름을 두 곳에 따로 적으면 한쪽만 바뀌는 날 링크가 조용히 죽는다 —
 * 그래서 둘 다 이 파일만 본다.
 *
 * 계약: docs/problem-hub-v2/BE-20261002-reply-problem-ocr-origin.md — 문제 상세(GET·PATCH)의
 * `ocr_project_id`·`ocr_prob_id`(정수|null, 늘 짝). 운영 배포 전 서버는 두 칸이 **아예 없다** →
 * null 과 똑같이 다룬다(회신 §2-3). 그래서 푸시 순서와 상관없이 배지는 글자로 남을 뿐이다.
 * 반대 방향(검수 모달 → 문제)은 OCR 상세의 promoted_problem_id 가 이미 맡는다(OcrReviewModal 「등록됨」 배지).
 */
export const OCR_REVIEW_PARAM = 'review';

// 양의 정수만 번호로 본다 — 빈 값·0·숫자 아닌 글자는 「없음」이다
function toId(v) {
  if (typeof v === 'number') return Number.isInteger(v) && v > 0 ? v : null;
  if (typeof v === 'string' && /^\d+$/.test(v)) {
    const n = Number(v);
    return n > 0 ? n : null;
  }
  return null;
}

/** 두 번호로 주소를 만든다. 하나라도 번호가 아니면 null */
export function ocrReviewPath(projectId, ocrProbId) {
  const p = toId(projectId);
  const o = toId(ocrProbId);
  if (p == null || o == null) return null;
  return `/ocr-hub/project/${p}?${OCR_REVIEW_PARAM}=${o}`;
}

/** 문제 상세 → 그 문제를 만든 OCR 검수 화면 주소. 두 칸 중 하나라도 없으면(null·옛 서버의 undefined) null */
export function ocrReviewPathOf(detail) {
  return ocrReviewPath(detail?.ocr_project_id, detail?.ocr_prob_id);
}

/** 주소에 실려 온 검수 대상 번호 — URLSearchParams 를 받는다. 없거나 번호가 아니면 null */
export function readOcrReviewParam(searchParams) {
  return toId(searchParams?.get?.(OCR_REVIEW_PARAM) ?? null);
}
